//
//
//
//
//
//

import ico1 from '@/assets/dzsw-01.png'
import ico2 from '@/assets/dzsw-02.png'

export default {
  name: 'home',
  data () {
    return {
      ico1: ico1,
      ico2: ico2
    }
  },
  created () {
  },
  components: {
  },
  methods: {

  }
}
